import api from './axios';

export const listar          = (params) => api.get('/audit-logs/', { params });
export const listarEntidades = ()       => api.get('/audit-logs/entidades');
export const listarAcoes     = ()       => api.get('/audit-logs/acoes');
export const getResumo       = (dias)   => api.get('/audit-logs/resumo', { params: dias ? { dias } : {} });
